import React, { useEffect } from 'react';
import { InputField } from '../../../../utility/form/';
import useContactUs from './useContactUs';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../../../../utility/button/LoadingButton';
import Testimonial from '../Testimonials/Testimonial';
import { contactBg } from '../../../../../images';
import { getBrandName } from '../../Components/getBrandName';

const ContactSection = () => {
  const { t } = useTranslation();
  const {mail } = getBrandName();
  const {
    form,
    onChange,
    onSubmit,
    loading,
    errors,
  } = useContactUs();
  
  useEffect(() => {
    // ✅ Select the static container
    const staticContainer = document.querySelector(".static-container");
    if (!staticContainer) return; // safeguard if not found

    // 🟢 Save old background before changing
    const oldBackground = staticContainer.style.backgroundImage;
    const oldBgColor = staticContainer.style.backgroundColor;
    const oldBgSize = staticContainer.style.backgroundSize;
    const oldBgRepeat = staticContainer.style.backgroundRepeat;
    const oldBgPosition = staticContainer.style.backgroundPosition;
    const oldBgAttachment = staticContainer.style.backgroundAttachment;

    // 🟣 Apply About Us background image
    staticContainer.style.backgroundImage = `url(${contactBg})`;
    staticContainer.style.backgroundSize = "cover";
    staticContainer.style.backgroundRepeat = "no-repeat";
    staticContainer.style.backgroundPosition = "center";
    staticContainer.style.backgroundAttachment = "fixed";
    staticContainer.style.transition = "background 0.5s ease-in-out";

    // 🔴 Cleanup: restore old background when leaving AboutUs
    return () => {
      staticContainer.style.backgroundImage = oldBackground;
      staticContainer.style.backgroundColor = oldBgColor;
      staticContainer.style.backgroundSize = oldBgSize;
      staticContainer.style.backgroundRepeat = oldBgRepeat;
      staticContainer.style.backgroundPosition = oldBgPosition;
      staticContainer.style.backgroundAttachment = oldBgAttachment;
    };
  }, []);

  return (
    <>
     <section className="contact-section">
      <div className="contact-container">
        {/* Header */}
        <div className="contact-header">
          <div>
            <span className='contact-heading'>Let’s Close the Gap Between</span> <br />
            <span className='contact-heading-below'>Data and Clarity.</span>
          </div>
          <p className="contact-subtitle">
            Have a question, need a demo, or just want to explore how
            <br /> Gapalzye can simplify your Amazon analytics?
            <br />
            We’d love to hear from you.
          </p>
        </div>

        {/* Content */}
        <div className="contact-content">
          {/* Left Side - Info */}
          <div className="contact-info">
            <h3>Get In Touch</h3>
            <p>
              Join thousands of sellers who trust us to power their marketplace
              business.
            </p>
            <address>
              103, Sanghi Manor, Yeshwant Niwas Rd,
              <br />
              Indore, Madhya Pradesh 452003
            </address>
            <p className="contact-phone">+91-6262606167</p>
            <p className="contact-email">
              {mail}
            </p>
          </div>
          {/* Right Side - Form */}
          <form className="contact-form" onSubmit={onSubmit} noValidate>
            <label>
              Name *
              <input type="text" name="name" value={form.name} onChange={onChange} placeholder="Enter your name" />
              {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}

            </label>
            <label>
              Email *
              <input type="email" name="email" value={form.email} onChange={onChange} placeholder="Enter your email" />
              {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
            </label>
            <label>
              Subject *
              <input type="text" name="subject" value={form.subject} onChange={onChange} placeholder="Enter your subject" />
              {errors.subject && <div className="invalid-feedback d-block">{errors.subject}</div>}
            </label>
            <label>
              Message *
              <textarea value={form.message} name="message" placeholder="Enter your message" onChange={onChange} />
              {errors.message && <div className="invalid-feedback d-block">{errors.message}</div>}
            </label>
            <button type="submit">Send</button>
          </form>
        </div>
      </div>
    </section>
    {/* <div className="" style={{padding: "6rem 9rem"}}> */}
             <Testimonial />
             {/* </div> */}
    </>
    // <div className="contact-section py-5">
    //   <div className="container">
    //     <h2 className="text-center fw-bold mb-2">Get In Touch</h2>
    //     <p className="text-center text-muted mb-4">
    //       Join thousands of sellers who trust us to power their marketplace business.
    //     </p>

    //     <div className="contact-wrapper row shadow mx-0">
    //       {/* Left Info */}
    //       <div className="col-md-5 contact-info-box">
    //         <h3><i className="bi bi-telephone-fill me-2"></i> Contact Information</h3>
    //         <p className="desc">
    //           We’ll create high-quality, trackable content and build at least 40× higher visibility.
    //         </p>

    //         <div className="info-item">
    //           <i className="bi bi-geo-alt-fill"></i>
    //           <div>
    //             <h6>Address</h6>
    //             <p>103, Sanghi Manor, Yeshwant Niwas Rd, Indore, Madhya Pradesh 452003</p>
    //           </div>
    //         </div>

    //         <div className="info-item">
    //           <i className="bi bi-phone-fill"></i>
    //           <div>
    //             <h6>Phone</h6>
    //             <p>+91-9630303150</p>
    //           </div>
    //         </div>

    //         <div className="info-item">
    //           <i className="bi bi-envelope-fill"></i>
    //           <div>
    //             <h6>Email</h6>
    //             <p>hello@throughouttechnologies.com</p>
    //           </div>
    //         </div>
    //       </div>

    //       {/* Right Form */}
    //       <div className="col-md-7 contact-form-box">
    //         <form onSubmit={onSubmit} noValidate>
    //           <div className="row g-3">
    //             <div className="col-12 col-md-12 col-lg-6">
    //               <InputField
    //                 label="Name*"
    //                 name="name"
    //                 value={form.name}
    //                 onChange={onChange}
    //                 error={errors.name}
    //                 placeholder="Enter your Name"
    //                 type="text"
    //               />
    //             </div>
    //             <div className="col-12 col-md-12 col-lg-6">
    //               <InputField
    //                 label="Email *"
    //                 name="email"
    //                 value={form.email}
    //                 onChange={onChange}
    //                 error={errors.email}
    //                 placeholder="Enter your email address"
    //                 type="email"
    //               />
    //             </div>
    //           </div>

    //           <div className="mt-3">
    //             <InputField
    //               label="Subject *"
    //               name="subject"
    //               value={form.subject}
    //               onChange={onChange}
    //               error={errors.subject}
    //               placeholder="Enter your subject"
    //               type="text"
    //             />
    //           </div>

    //           <div className="mt-3">
    //             <InputField
    //               label="Message *"
    //               name="message"
    //               value={form.message}
    //               onChange={onChange}
    //               error={errors.message}
    //               placeholder="Enter the message"
    //               as="textarea"
    //               rows={4}
    //             />
    //           </div>

    //           <LoadingButton
    //             type="submit"
    //             disabled={loading}
    //             isLoading={loading}
    //             className="btn w-100 mt-4"
    //           >
    //             Contact Us
    //           </LoadingButton>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default ContactSection;
